import { Box, Flex, Spacer, Tab, TabList, TabPanel, TabPanels, Tabs, Text, VStack, chakra, useToast } from '@chakra-ui/react';
import MainHeader from '../MainHeader';
import UserHeaderLivre from 'components/AreaLivre/UserHeaderLivre';
import useViewDashboard from './useViewDashboard';
import CardEspecialidadesNaoAssinantes from './CardEspecialidadesNaoAssinantes';
import CardsTelemedicina from './Cards/Telemedicina/CardsTelemedicina';
import CardsEspecialistas from './Cards/Especialistas/CardsEspecialistas';
import ClubeVantagens from './Cards/ClubeVantagens/ClubeVantagens';
import AtendimentoPresencial from './Cards/Presencial/AtendimentoPresencial';
import BottomNavBar from 'components/BottomNavBar';
import ModalLogin from '../ModalLogin';
import { useEffect, useState } from 'react';
import AvisoAtendimento from '../DashboardAlerts/AvisoAtendimento';
import AvisoDependente from '../DashboardAlerts/AvisoDependente';
import ButtonTelemedicina from 'components/Dashboard/ButtonTelemedicina/ButtonTelemedicina';
import ButtonNotificacao from 'components/Dashboard/ButtonNotificacao/ButtonNotificacao';
import VerificaAdesao from 'components/Dashboard/VerificaAdesao/VerificaAdesao';
import AvisoAnaliseContrato from '../DashboardAlerts/AvisoAnaliseContrato';
import AvisoTelefone from '../DashboardAlerts/AvisoTelefone';
import ModalCartaoV5Pagarme from 'components/Dashboard/Modal/ModalCartaoV5Pagarme';
import ModalClienteImportado from 'components/Dashboard/ModalClienteImportado';
import ModalDeslogar from '../ModalDeslogar';
import LogoDashboard from '../../../../images/petalas-deovita.svg';
import useRoutes from 'components/Utils/Functions/useRoutes';

function Main() {
  const {
    user,
    assinante,
    loading,
    error,
    valor,
    toastInadimplente,
    clientePendente,
    disclosureAtendimento,
    modalDependentes,
    modalClienteImportado,
    modalDeslogar,
    disclosureTelefone,
    modalCartaoV5,
  } = useViewDashboard();
  const [lastRouteData, setLastRouteData] = useState(null);
  const navigateByRoute = useRoutes();
  const toast = useToast();

  const [tabIndex, setTabIndex] = useState(() => {
    const saved = localStorage.getItem('dashboardTabIndex');
    return saved !== null ? Number(saved) : 0;
  });

  useEffect(() => {
    if (clientePendente) {
      toastInadimplente(user.id_forma_pagamento, user.qntdeParcelas);
    }
  }, [assinante, clientePendente]);

  useEffect(() => {
    if (localStorage.getItem('plano_trocado_sucesso')) {
      toast({
        duration: 4000,
        isClosable: true,
        position: 'bottom',
        render: () => (
          <Box
            display="flex"
            alignItems="center"
            bgGradient="linear(135deg, #5AB2AE 0%, #4AA09C 100%)"
            color="white"
            borderRadius="xl"
            boxShadow="lg"
            px={6}
            py={4}
            maxW="350px"
            mx="auto"
          >
            <Box
              minW="48px"
              minH="48px"
              maxW="48px"
              maxH="48px"
              mr={4}
              display="flex"
              alignItems="center"
              justifyContent="center"
              borderRadius="full"
              boxShadow="md"
              border="2px solid #5AB2AE"
              overflow="hidden"
            >
              <img src={LogoDashboard} alt="Logo DeoVita" style={{ width: '40px', height: '40px', objectFit: 'contain', display: 'block' }} />
            </Box>
            <Box>
              <Text fontWeight="bold" fontSize="lg" mb={1} color="#fff">
                Sucesso
              </Text>
              <Text fontSize="sm" color="#fff">
                Seu plano foi alterado com sucesso!
              </Text>
            </Box>
          </Box>
        ),
      });
      localStorage.removeItem('plano_trocado_sucesso');
    }
  }, [toast]);

  return (
    <>
      <AvisoAnaliseContrato />
      <AvisoTelefone disclosure={disclosureTelefone} />
      <AvisoAtendimento disclosure={disclosureAtendimento} />
      <AvisoDependente disclosure={modalDependentes} />
      <ModalCartaoV5Pagarme disclosure={modalCartaoV5} />
      <ModalClienteImportado disclosure={modalClienteImportado} />
      <ModalDeslogar disclosure={modalDeslogar} />
      {user.loggedIn === true ? <MainHeader /> : <UserHeaderLivre />}
      <Box w="100%" maxW="600px" mx="auto" mt={4} bg="white" pb={8}>
        {!assinante && !user?.id_plano && (
          <>
            <VStack pt={{ base: '10px', sm: '20px', md: '60px' }} pb={{ base: '10px', sm: '20px', md: '60px' }}>
              <Box>
                <CardEspecialidadesNaoAssinantes />
              </Box>
            </VStack>
          </>
        )}
        <Tabs
          isFitted
          index={tabIndex}
          onChange={(i) => {
            setTabIndex(i);
            localStorage.setItem('dashboardTabIndex', i);
          }}
        >
          <TabList mx={3} borderRadius="1em" p="3px" bg="#FFFFFF" mb={-8}>
            <Tab
              fontWeight="bold"
              fontSize={'1.2em'}
              py={3}
              _selected={{
                color: 'white',
                bg: '#5AB2AE',
                borderRadius: '0.8em',
                boxShadow: 'md',
              }}
              color="#9E9E9E"
              borderRadius="0.8em"
              bg="#FFFFFF"
            >
              Telemedicina
            </Tab>

            <Tab
              fontWeight="bold"
              fontSize={'1.2em'}
              py={3}
              _selected={{
                color: 'white',
                bg: '#5AB2AE',
                borderRadius: '0.8em',
                boxShadow: 'md',
              }}
              color="#9E9E9E"
              borderRadius="0.8em"
              bg="#FFFFFF"
            >
              Presencial
            </Tab>
          </TabList>

          <TabPanels>
            <TabPanel px={0}>
              <VStack justifyContent="center" alignItems="center" minHeight="100vh" spacing={6} w="100%">
                <Flex w="100%" justify="center" mt={4}>
                  <Box border="1px solid #5AB2AE" borderRadius="1em" boxShadow="lg" p={4} w="96%" maxW="480px">
                    <VStack bg="#E1F1F1" borderRadius="full" p={2} spacing={4} alignItems="center" justifyContent="center">
                      <chakra.h1 fontSize="1em" color="#23756D" textAlign="center" w="100%" fontWeight={'bold'}>
                        Pronto Atendimento <br />
                        para você na palma da mão
                      </chakra.h1>
                    </VStack>

                    <Spacer mt={10} />

                    <CardsTelemedicina
                      assinante={assinante}
                      prontoAtendimento={valor?.prontoAtendimento}
                      loading={loading}
                      error={error}
                      gratuito={valor.prontoAtendimento_gratis}
                    />
                    <VStack bg="#E1F1F1" borderRadius="full" spacing={4} alignItems="center" justifyContent="center" mt={4}>
                      <chakra.h1 fontSize="1em" color="#23756D" textAlign="center" w="100%" fontWeight={'bold'} mt={2} mb={2}>
                        Agende sua consulta <br />
                        com especialista online
                      </chakra.h1>
                    </VStack>
                    <CardsEspecialistas assinante={assinante} loading={loading} especialista={valor?.especialista} error={error} />
                  </Box>
                </Flex>

                {user && user.loggedIn === false ? <Box>{<ModalLogin />}</Box> : <></>}
              </VStack>
            </TabPanel>

            <TabPanel px={0}>
              <AtendimentoPresencial assinante={assinante} />
            </TabPanel>
          </TabPanels>
        </Tabs>
        <ClubeVantagens assinante={assinante} clientePendente={clientePendente} />
        <Spacer mb={20} />
      </Box>
      {user.loggedIn && <ButtonTelemedicina />}
      {user.loggedIn && <ButtonNotificacao />}
      {!assinante && !clientePendente && user.adesao_pendente && <VerificaAdesao />}
      <BottomNavBar name="dashboard" />
    </>
  );
}

export default Main;
